// extracted by mini-css-extract-plugin
module.exports = {"base":"Tasks_base__GCIQI","cell":"Tasks_cell__1fu5l","dropDownSelection":"Tasks_dropDownSelection__1-gSg"};